<template>
  <v-card v-if="$vuetify.breakpoint.smAndDown" flat class="transparent text--white align-center justify-center d-flex">
    <v-card flat class="text--white transparent flex-column pt-12 pb-12" width="90%">
      <v-card class="transparent mt-12" flat height="40vh">
        <v-img
          :src="require('@/assets/phone.png')"
          height="20%"
          contain
          class="text-center"
        ></v-img>
        <div
          class="subtitle text-center ml-6 mr-6 mt-6" style="font-size:18px"
          v-html="$t('page2_home.text1')"
        ></div>
      </v-card>
      <!-- <v-col clos="1">
      </v-col>-->
      <v-card class="transparent" flat height="50vh">
        <v-img
          :src="require('@/assets/desktop.png')"
          height="20%"
          contain
          class="text-center"
        ></v-img>
        <div
          class="subtitle text-center ml-6 mr-6 mt-6" style="font-size:18px"
          v-html="$t('page2_home.text2')"
        ></div>
        <!--<div class="arrow-go-down">-->
        <!--<v-img-->
        <!--:src="require('@/assets/arrow_down.png')"-->
        <!--height="20%"-->
        <!--style="cursor:pointer !important;"-->
        <!--contain-->
        <!--@click="scrolldown()"-->
        <!--/>-->
        <!--</div>-->
      </v-card>
    </v-card>
  </v-card>
  <v-card v-else flat class="transparent text--white align-center justify-center d-flex fill-height">
    <v-card flat class="text--white transparent mt-12 pt-12 d-flex flex-row justify-center " width="70%">
      <v-col clos="6">
        <v-img
          :src="require('@/assets/phone.png')"
          height="250"
          contain
          class="text-center"
        ></v-img>
        <div
          class="reddle-feature reddle-description-text text-center"
          v-html="$t('page2_home.text1')"
        ></div>
      </v-col>
      <!-- <v-col clos="1">
      </v-col>-->
      <v-col clos="6">
        <v-img
          :src="require('@/assets/desktop.png')"
          height="250"
          contain
          class="text-center"
        ></v-img>
        <div
          class="reddle-feature reddle-description-text text-center"
          v-html="$t('page2_home.text2')"
        ></div>
        <!--<div class="arrow-go-down">-->
        <!--<v-img-->
        <!--:src="require('@/assets/arrow_down.png')"-->
        <!--height="20%"-->
        <!--style="cursor:pointer !important;"-->
        <!--contain-->
        <!--@click="scrolldown()"-->
        <!--/>-->
        <!--</div>-->
      </v-col>
    </v-card>
  </v-card>
</template>
<script>
  export default {
    data: () => ({}),
    methods: {
      scrolldown() {
        console.log("scrolling down now ", document.querySelector("#page2_home"));
        document
          .querySelector("#page3_home")
          .scrollIntoView({ behavior: "smooth" });
      }
    }
  };
</script>
